import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable }  from 'rxjs/Observable';
import { Project } from '../project'
import { RuntimeService } from '../runtime.service'
import { Criterion } from '../criterion'
import { CriterionService } from '../criterion.service'
import { CriterionItem } from '../criterion-item'
import { AdminService } from '../admin.service'
import { SortService } from '../sort.service'

@Component({
  selector: 'app-criterion-summary',
  templateUrl: './criterion-summary.component.html',
  styleUrls: ['./criterion-summary.component.css']
})
export class CriterionSummaryComponent implements OnInit {

  constructor(
    private router: Router,
    public rts: RuntimeService,
    private cs: CriterionService,
    private ads: AdminService,
    private ss: SortService
  ) { }

  @Input() isEdit: boolean
  @Input() criterion: Criterion
  @Input() inProjectSummary = false

  private _criterionTitle = ''
  private submitCriterionClicked = false
  private isDelete = false

  ngOnInit() {
    if (!this.criterion && this.cs.currentCriterion)
      this.criterion = this.cs.currentCriterion

    if (!this.criterion && this.rts.currentProject)
      this.criterion = this.cs.newCriterion()

    if (this.isEdit)
      this.cs.clearCriterionItemValues()
    this._criterionTitle = this.criterion.title
  }

  ngOnDestroy() {
    if (this.criterion && this.criterion.isNew)
      this.rts.currentProject.criterionsMap.delete(this.criterion.id)
    if (this.ss.position(this.criterion.id) != 0)
      this.cs.currentCriterion = null
  }

  switchEdit(runClear?: boolean) {
    if (runClear) {
      this.ads.clearSwitches()
      this.isEdit = false
    }
    if (this.isEdit)
      this.ngOnDestroy()
    else
      this.cs.currentCriterion = this.criterion
    this.isEdit = !this.isEdit
    this.ads.newCriterionOn = this.isEdit
  }

  newCriterionItem() {
    this.cs.addItem(this.criterion)
    console.log(this.criterion)
  }

  get title() {
    return this._criterionTitle
  }

  set title(txt) {
    this._criterionTitle = txt.trim()
  }

  get criterionItems(): CriterionItem[] {
    return this.criterion.items
  }

  save() {
    if (!this.title)
      return alert("TITLE MISSING")
    this.criterion.title = this.title
    this.cs.save(this.criterion)
  }

  switchDelete() {
    this.isDelete = !this.isDelete
  }

  confirmDelete() {
    let obs: Observable<any> = this.cs.delete(this.criterion)
    obs.subscribe((x) => null)
  }


}



// WEBPACK FOOTER //
// ./src/app/criterion-summary/criterion-summary.component.ts